"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var apisauce_1 = tslib_1.__importDefault(require("apisauce"));
var config_1 = tslib_1.__importDefault(require("../config"));
var instances = {};
var create = function (authToken, baseURL) {
    if (typeof authToken !== 'string')
        throw new Error('Waldo.create() requires an authToken as the first parameter');
    var instanceId = authToken + baseURL;
    if (typeof instances[instanceId] !== 'undefined')
        return instances[instanceId];
    var api = apisauce_1.default.create({
        baseURL: baseURL,
        headers: {
            'Content-Type': 'application/json',
            Authorization: "Bearer ".concat(authToken),
        },
        timeout: config_1.default.TIMEOUT,
    });
    // URL Builders
    var buildGetUserLocation = function (userId) { return "/".concat(userId); };
    var buildSetUserLocation = function (userId) { return "/".concat(userId); };
    var buildSetUserLocationNotShared = function (userId) {
        return "/location_not_shared/".concat(userId);
    };
    var getUserLocation = function (userId) {
        return api.get(buildGetUserLocation(userId)).then(function (response) {
            if (response.ok) {
                return response.data;
            }
            else {
                throw response.data;
            }
        });
    };
    var setUserLocation = function (userId, location) {
        return api.post(buildSetUserLocation(userId), location).then(function (response) {
            if (response.ok) {
                return response.data;
            }
            throw response.data;
        });
    };
    var setUserLocationNotShared = function (userId) {
        return api.post(buildSetUserLocationNotShared(userId)).then(function (response) {
            if (response.ok) {
                return response.data;
            }
            throw response.data;
        });
    };
    instances[instanceId] = {
        getUserLocation: getUserLocation,
        setUserLocation: setUserLocation,
        setUserLocationNotShared: setUserLocationNotShared,
    };
    return instances[instanceId];
};
exports.default = {
    create: create,
};
